// Stops Enter in a field from implicitly submitting the form it is placed on.
// Barcode scanners type the code and then press Enter, which on a long clinical form
// (workup plan, operation note) would submit the whole thing and land the user on the
// success modal. Textareas, buttons and ui-select keep their own Enter handling, and
// fields belonging to a nested form (e.g. "add incision") are left alone.
app.directive("preventEnterSubmit", [
	function () {
		var ENTER_KEY_CODE = 13;
		var ALLOWED_TAGS = ["TEXTAREA", "BUTTON"];

		return {
			restrict: "A",
			link: function (scope, element) {
				var form = element[0];

				function onKeyDown(event) {
					if ((event.which || event.keyCode) !== ENTER_KEY_CODE) return;

					var target = event.target;
					if (!target || target.form !== form) return;
					if (ALLOWED_TAGS.indexOf(target.tagName) !== -1) return;
					if (target.type === "submit" || target.type === "button") return;

					event.preventDefault();
				}

				form.addEventListener("keydown", onKeyDown);
				scope.$on("$destroy", function () {
					form.removeEventListener("keydown", onKeyDown);
				});
			},
		};
	},
]);
